(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    const heroes = document.querySelectorAll(".hero-wrapper .hero");
    if (heroes.length === 2) {
      heroes[0].classList.add("hero--desktop-only");
      heroes[1].classList.add("hero--mobile-only");
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
